module.exports = __webpack_public_path__ + "static/media/sg3.424427fe.png";